var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SAText } from '../../text';
var CardContainer = styled.article.attrs(function (_a) {
    var addVerticalSeparator = _a.addVerticalSeparator, height = _a.height, width = _a.width;
    return ({
        addVerticalSeparator: addVerticalSeparator,
        height: height,
        width: width,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var addVerticalSeparator = props.addVerticalSeparator, height = props.height, theme = props.theme, width = props.width;
    var spacerLarge = theme === null || theme === void 0 ? void 0 : theme.size.spacer.large;
    var separator = theme === null || theme === void 0 ? void 0 : theme.separator.line;
    var verticalSeparatorAddition = addVerticalSeparator ? spacerLarge : '0px';
    return "\n      border-left: " + (addVerticalSeparator ? (separator === null || separator === void 0 ? void 0 : separator.thickness) + " solid " + (separator === null || separator === void 0 ? void 0 : separator.color) : 'none') + ";\n      padding-left: " + (addVerticalSeparator ? spacerLarge : '0') + ";\n      margin-left: " + (addVerticalSeparator ? spacerLarge : '0') + ";\n\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.foreground) + ";\n      display: flex;\n      flex-flow: column;\n      height: " + (height ? height + "px" : 'initial') + ";\n      min-height: " + (height ? height + "px" : 'initial') + ";\n      min-width: " + (width ? width + "px" : 'initial') + ";\n      width: calc(" + (width ? width + "px" : '100%') + " + " + verticalSeparatorAddition + ");\n\n      @media only screen and (max-width: 600px) {\n        border-left: 0;\n        padding-left: 0;\n        margin-left: 0;\n        width:" + (width ? width + "px" : '100%') + ";\n      }\n    ";
});
// TODO: Figure out why this any type is needed. They're everywhere in SC.
var CardHeader = styled.header.attrs(function (_a) {
    var removePadding = _a.removePadding;
    return ({
        removePadding: removePadding,
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var removePadding = props.removePadding, theme = props.theme;
    var separator = theme === null || theme === void 0 ? void 0 : theme.separator.line;
    var spacerSmall = theme === null || theme === void 0 ? void 0 : theme.size.spacer.small;
    return "\n      border-bottom: " + (separator === null || separator === void 0 ? void 0 : separator.thickness) + " solid " + (separator === null || separator === void 0 ? void 0 : separator.color) + ";\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      > h4 {\n        padding: " + (!removePadding ? "0 0 " + spacerSmall : '0') + ";\n      }\n    ";
});
var CardContent = styled.section.attrs(function (_a) {
    var removePadding = _a.removePadding;
    return ({
        removePadding: removePadding,
    });
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var removePadding = props.removePadding, theme = props.theme;
    var spacerSmall = theme === null || theme === void 0 ? void 0 : theme.size.spacer.small;
    return "\n      padding: " + (!removePadding ? spacerSmall + " 0" : '0') + ";\n\n      > * {\n        position: static;\n      }\n\n      @media only screen and (max-width: 600px) {\n        padding: " + (!removePadding ? spacerSmall + " 0 0" : '0') + ";\n      }\n    ";
});
export function SACardVariantSubTitled(_a) {
    var addVerticalSeparator = _a.addVerticalSeparator, children = _a.children, decorator = _a.decorator, height = _a.height, removePadding = _a.removePadding, title = _a.title, width = _a.width, rest = __rest(_a, ["addVerticalSeparator", "children", "decorator", "height", "removePadding", "title", "width"]);
    if (title) {
        return (React.createElement(CardContainer, __assign({ addVerticalSeparator: addVerticalSeparator, height: height, width: width }, rest),
            React.createElement(CardHeader, { removePadding: removePadding },
                React.createElement(SAText, { text: title, type: "heading-4" }),
                decorator),
            React.createElement(CardContent, { removePadding: removePadding }, children)));
    }
    return (React.createElement(CardContainer, __assign({ addVerticalSeparator: addVerticalSeparator, height: height, width: width }, rest),
        React.createElement(CardHeader, { removePadding: removePadding },
            React.createElement(SAText, { text: " ", type: "heading-4" }),
            decorator),
        React.createElement(CardContent, { removePadding: removePadding }, children)));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=card.variant.sub-titled.component.js.map